"use client"

import { useState, useEffect } from "react"
import api from "../../api/api"
import { useNavigate, useLocation } from "react-router-dom"
import Loading from "../../Loading"
import { ExternalLink } from "lucide-react"

const PressReleaseTable = ({ secCode }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const [pressRelease, setPressRelease] = useState(null)
  const [isMobile, setIsMobile] = useState(false)

  // 画面サイズの変更を検知
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 768)
    }

    checkIfMobile()
    window.addEventListener("resize", checkIfMobile)

    return () => {
      window.removeEventListener("resize", checkIfMobile)
    }
  }, [])

  useEffect(() => {
    const fetchPressRelease = async () => {
      try {
        const response = await api.get(`${process.env.REACT_APP_API_URL}/chat/api/press-release-list/${secCode}/`, {})
        console.log(response.data)
        setPressRelease(response.data)
      } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          // 未認証の場合、ログイン画面にリダイレクト
          navigate("/login", { state: { from: location.pathname } })
        } else {
          console.error("Error fetching timely disclosures:", error)
        }
      }
    }
    fetchPressRelease()
  }, [secCode, navigate, location.pathname])

  if (!pressRelease) {
    return <Loading />
  }

  return (
    <div className="dashboard-row max-h-[600px] overflow-y-auto overflow-x-hidden" style={{ marginTop: 0 }}>
      <h3>プレスリリース</h3>

      {isMobile ? (
        // モバイル表示 - カードレイアウト
        <div className="space-y-4 max-h-[500px] overflow-y-auto overflow-x-hidden px-2">
          {pressRelease.map((data) => (
            <div
              key={data.press_release_url}
              className="border rounded-lg p-3 shadow-sm hover:shadow-md transition-shadow"
            >
              <div className="text-sm font-medium text-gray-500 mb-1">{data.date}</div>
              <a
                href={data.press_release_url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-gray-800 font-medium flex items-start gap-1"
              >
                <span className="flex-1">{data.title}</span>
                <ExternalLink size={16} className="flex-shrink-0 mt-1" />
              </a>
            </div>
          ))}
        </div>
      ) : (
        // デスクトップ表示 - テーブルレイアウト
        <div className="max-h-[500px] overflow-y-auto overflow-x-hidden">
          <table className="disclosure-table press-release-table w-full">
            <thead>
              <tr>
                <th className="text-left">公表日</th>
                <th className="text-left w-full">タイトル</th>
              </tr>
            </thead>
            <tbody>
              {pressRelease.map((data) => (
                <tr key={data.press_release_url}>
                  <td className="text-left">{data.date}</td>
                  <td className="text-left">
                    <a
                      href={data.press_release_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:underline"
                    >
                      {data.title}
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}

export default PressReleaseTable
